<template>
    <div class="titulo">
        <div class="margem container">
            <!-- <div class="m-icone direita"><button @click="criarPAP()" class="acao-secundaria">Novo PAP</button></div> -->
            <div class="m-icone direita">
                <div class="pesquisa">
                    <input type="text" placeholder="Pesquisar PAP" v-model="planoSelecionado"
                        @input="filtrarPlanosDeAcao()" />
                    <a class="icone-pesquisa"></a>
                </div>
            </div>
            <h2>Planos de Alteração de Produto/Processo</h2>
        </div>
    </div>
    <div class="margem container">
        <div>
            <div class="container">
                <div class="bloco margem">
                    <table class="tabela">
                        <tbody>
                            <tr>
                                <th scope="col" style="text-align: center;">
                                    Código
                                </th>
                                <th scope="col" style="text-align: center; white-space: nowrap;">
                                    <span @click="ordenarLista('nome')">
                                        Assunto
                                    </span>
                                    <i class="bi bi-caret-down-fill" style="display: none;" id="setaBaixonome"></i>
                                    <i class="bi bi-caret-up-fill" style="display: none;" id="setaCimanome"></i>
                                </th>
                                <th scope="col">
                                    <span @click="ordenarLista('status')" style="cursor: pointer;">
                                        Status
                                    </span>
                                    <i class="bi bi-caret-down-fill" style="display: none;" id="setaBaixostatus"></i>
                                    <i class="bi bi-caret-up-fill" style="display: none;" id="setaCimastatus"></i>
                                </th>
                                <th scope="col" style="width: 10rem;">
                                    <span @click="ordenarLista('dtInicio')" style="cursor: pointer;">
                                        Data de Início
                                    </span>
                                    <i class="bi bi-caret-down-fill" style="display: none;" id="setaBaixodtInicio"></i>
                                    <i class="bi bi-caret-up-fill" style="display: none;" id="setaCimadtInicio"></i>
                                </th>
                                <th scope="col" style="width: 10rem;">
                                    <div style="display: flex; align-items: center;">
                                        <span @click="ordenarLista('dtTermino')" style="cursor: pointer;">
                                            Data de Término
                                        </span>
                                        <i class="bi bi-caret-down-fill" style="display: none;"
                                            id="setaBaixodtTermino"></i>
                                        <i class="bi bi-caret-up-fill" style="display: none;"
                                            id="setaCimadtTermino"></i>
                                    </div>
                                </th>
                                <th scope="col">
                                    <div style="display: flex; align-items: center;">
                                        <span @click="ordenarLista('gerente_name')" style="cursor: pointer;">
                                            Gerente Responsável
                                        </span>
                                        <i class="bi bi-caret-down-fill" style="display: none;"
                                            id="setaBaixogerente_name"></i>
                                        <i class="bi bi-caret-up-fill" style="display: none;"
                                            id="setaCimagerente_name"></i>
                                    </div>
                                </th>
                                <th scope="col">
                                    <div style="display: flex; align-items: center;">
                                        <span @click="ordenarLista('setor_nome')" style="cursor: pointer;">
                                            Setor Envolvido
                                        </span>
                                        <i class="bi bi-caret-down-fill" style="display: none;"
                                            id="setaBaixosetor_nome"></i>
                                        <i class="bi bi-caret-up-fill" style="display: none;"
                                            id="setaCimasetor_nome"></i>
                                    </div>
                                </th>
                                <th scope="col"></th>
                            </tr>
                            <tr v-for="item in listaPlanosFiltrada" :key="item.id" style="text-align: center;"
                                @mouseover="mostrarBotao(item.id, true)" @click="abrirPAP(item)"
                                @mouseleave="mostrarBotao(item.id, false)">
                                <td style="vertical-align: middle; text-align: center; cursor: pointer;">{{
                                    item.pcm_codigo ?
                                        item.pcm_codigo : '-' }}</td>
                                <td style="vertical-align: middle; text-align: center; cursor: pointer">{{
                                    item.nome }}</td>
                                <td style="vertical-align: middle;" class="clicavel">
                                    <select v-model="item.status" class="form-select"
                                        :style="{ 'color': (item.status === 'Aprovado') ? '#00B6B3' : (item.status === 'Em andamento') ? 'var(--cor-ok)' : (item.status === 'Concluído') ? 'var(--cor-sucesso)' : '#FFA500' }"
                                        style="opacity: 1;background-color: transparent;width: fit-content; outline: none; text-align: center; border: none;"
                                        @click.stop @change="editarPlanoInline(item.id, 'status', item.status)">
                                        <option style="color: #00B6B3;">Aprovado</option>
                                        <option style="color: var(--cor-ok);">Em andamento</option>
                                        <option style="color: var(--cor-sucesso);">Concluído</option>
                                        <option style="color: #FFA500;">Suspenso</option>
                                    </select>
                                </td>
                                <td style="vertical-align: middle;">{{ item.dtInicio ? formatarDataBr(item.dtInicio, '') : '' }}</td>
                                <td style="vertical-align: middle;">{{ formatarDataBr(item.dtTermino) }}</td>
                                <td style="vertical-align: middle;" class="text-nowrap">{{ item.gerente_name
                                    ?
                                    nomeEsobrenome(item.gerente_name) : '-' }}</td>
                                <td style="vertical-align: middle;">{{ item.setor_nome }}</td>
                                <td style="vertical-align: middle;">
                                    <div style="width: max-content; visibility: hidden;" :id="'botaoEdicao' + item.id">
                                        <v-menu v-if="Array.isArray(planosAcao) && planosAcao.length > 0">
                                            <template v-slot:activator="{ props }">
                                                <v-btn
                                                    style="width: 2rem; height: 2rem; border: 1px solid var(--cor-separador); color: var(--cor-fonte);"
                                                    class="botaoAdicionarSprint acao-secundaria"
                                                    icon="mdi-dots-horizontal" v-bind="props"></v-btn>
                                            </template>

                                            <v-list style="background-color: var(--cor-bg); color: var(--cor-fonte);">
                                                <v-list-item
                                                    
                                                    @click="modalCompartilharPlano = true, this.planoEditado = item, this.planoEditado.permissao = this.planoEditado.permissao.filter((pessoa) => pessoa.automatico === 0)">
                                                    Compartilhar
                                                    <br />
                                                </v-list-item>
                                                <v-list-item
                                                    
                                                    @click="abrirModalEditarPlano(item)">Editar
                                                </v-list-item>
                                                <v-list-item
                                                    
                                                    @click="modalFinalizarPlano = true, this.planoEditado = item">
                                                    Finalizar
                                                </v-list-item>
                                                <v-list-item
                                                    
                                                    @click="modalExcluirPlano = true, this.planoEditado = item"
                                                    style="color: var(--cor-erro);">
                                                    Excluir
                                                </v-list-item>
                                            </v-list>
                                        </v-menu>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div v-if="!planosAcao" class="loading" id="loading">
                        <div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <ModalCompartilharPlanoPAP
            :mostrar="modalCompartilharPlano"
            :plano="planoEditado || {}"
            :gerente="gerente"
            :id-usuario="idUsuario"
            @fechar="modalCompartilharPlano = false"
            @adicionar="(item) => atualizarPermissão(item, 'adicionar')"
            @remover="(item) => atualizarPermissão(item, 'remover')"
            @atualizar="(item) => atualizarPermissão(item, 'atualizar')"
        />
        <ModalFinalizarPlanoPAP
            :mostrar="modalFinalizarPlano"
            :plano-nome="planoEditado?.nome"
            @fechar="modalFinalizarPlano = false"
            @finalizar="onFinalizarPlano"
        />
        <ModalExcluirPlanoPAP
            :mostrar="modalExcluirPlano"
            :plano-nome="planoEditado?.nome"
            @fechar="fecharModalExcluirPlano"
            @confirmar="excluirPlano"
        />
        <ModalEditarPlanoPAP
            :mostrar="modalEditarPlano"
            :plano="planoEditado || {}"
            :gerente="gerente"
            :setores="setores"
            @fechar="modalEditarPlano = false"
            @editar="editarPlano"
        />
    </div>
</template>

<script>
import { useApiError } from "@/composables/useApiError";
import ModalCompartilharPlanoPAP from "@/components/Modais/PAP/ModalCompartilharPlanoPAP.vue";
import ModalEditarPlanoPAP from "@/components/Modais/PAP/ModalEditarPlanoPAP.vue";
import ModalExcluirPlanoPAP from "@/components/Modais/PAP/ModalExcluirPlanoPAP.vue";
import ModalFinalizarPlanoPAP from "@/components/Modais/PAP/ModalFinalizarPlanoPAP.vue";
import { sso } from "roboflex-thalamus-sso-lib";
import { consultarSetores } from "@/services/usuario-setor";
import serviceFunções from "@/services/serviceFunções";
import servicePCM from "@/services/servicePCM";
import servicePAP from "@/services/servicePAP";
import { formatarDataBr, dataParaInput } from "@/utils/date";

export default {
    name: "ControleDePAP",

    components: {
        ModalCompartilharPlanoPAP,
        ModalEditarPlanoPAP,
        ModalExcluirPlanoPAP,
        ModalFinalizarPlanoPAP,
    },

    setup() {
        const { handleError } = useApiError();
        return {
            formatarDataBr,
            dataParaInput,
            nomeEsobrenome: serviceFunções.nomeEsobrenome,
            handleApiError: handleError,
        };
    },

    data() {
        return {
            idUsuario: null,
            modalCompartilharPlano: false,

            planoSelecionado: null,
            listaPlanosFiltrada: null,

            modalNovoPA: false,
            planosAcao: null,
            novoPlanoAcao: {
                "nome": '',
                "dtInicio": dataParaInput(new Date().toISOString()),
                "gerente_id": '',
                "setor_id": '',
                "programa_id": ''
            },
            gerente: [],
            setores: [],
            modalEditarPlano: false,
            modalExcluirPlano: false,
            modalFinalizarPlano: false,
            planoEditado: null,

            teste: 'teste',
            dadosUser: null,
        }
    },

    mounted() {
        this.getPlanoAcao()
        this.getGerenteseSetor()
    },

    created() {
        const usuarioLogado = sso.getUsuarioLogado()
        // this.userName = usuarioLogado.nome // nome
        this.idUsuario = usuarioLogado.id // id
    },

    methods: {
        criarPAP() {
            this.$router.push({ name: "visualizacaoPAP", params: { idPAP: 'criar' } });
        },

        ordenarLista(chaveColuna) {
            for (var item of ['nome', 'status', 'dtInicio', 'dtTermino', 'gerente_name', 'setor_nome']) {
                if (item !== chaveColuna) {
                    document.getElementById(`setaBaixo${item}`).style.display = 'none'
                    document.getElementById(`setaCima${item}`).style.display = 'none'
                }
            }

            if (chaveColuna === 'dtInicio' || chaveColuna === 'dtTermino') {
                if (document.getElementById(`setaBaixo${chaveColuna}`).style.display === 'none') {
                    this.planosAcao = this.planosAcao.sort((a, b) => {
                        const dataInicioA = new Date(a[chaveColuna]);
                        const dataInicioB = new Date(b[chaveColuna]);
                        return dataInicioB - dataInicioA;
                    });
                    document.getElementById(`setaBaixo${chaveColuna}`).style.display = 'inline'
                    document.getElementById(`setaCima${chaveColuna}`).style.display = 'none'
                    return
                } else if (document.getElementById(`setaBaixo${chaveColuna}`).style.display === 'inline') {
                    this.planosAcao = this.planosAcao.sort((a, b) => {
                        const dataInicioA = new Date(a[chaveColuna]);
                        const dataInicioB = new Date(b[chaveColuna]);
                        return dataInicioA - dataInicioB;
                    });
                    document.getElementById(`setaBaixo${chaveColuna}`).style.display = 'none'
                    document.getElementById(`setaCima${chaveColuna}`).style.display = 'inline'
                    return
                }

            } else if (chaveColuna === 'status') {
                if (document.getElementById(`setaBaixo${chaveColuna}`).style.display === 'none') {

                    this.planosAcao = this.planosAcao.sort((a, b) => {
                        const order = {
                            'Em andamento': 1,
                            'Aprovado': 2,
                            'Proposto': 3,
                            'Concluído': 4,
                            'Suspenso': 5
                        };
                        const orderA = order[a.status] || 0;
                        const orderB = order[b.status] || 0;
                        if (orderA < orderB) {
                            return -1;
                        }
                        if (orderA > orderB) {
                            return 1;
                        }
                        return 0;
                    });


                    document.getElementById(`setaBaixo${chaveColuna}`).style.display = 'inline'
                    document.getElementById(`setaCima${chaveColuna}`).style.display = 'none'
                    return
                } else if (document.getElementById(`setaBaixo${chaveColuna}`).style.display === 'inline') {


                    this.planosAcao = this.planosAcao.sort((a, b) => {
                        const order = {
                            'Em andamento': 1,
                            'Aprovado': 2,
                            'Proposto': 3,
                            'Concluído': 4
                        };
                        const orderA = order[a.status] || 0;
                        const orderB = order[b.status] || 0;
                        if (orderA < orderB) {
                            return -1;
                        }
                        if (orderA > orderB) {
                            return 1;
                        }
                        return 0;
                    });


                    document.getElementById(`setaBaixo${chaveColuna}`).style.display = 'none'
                    document.getElementById(`setaCima${chaveColuna}`).style.display = 'inline'
                    return
                }
            }
            else {
                if (document.getElementById(`setaBaixo${chaveColuna}`).style.display === 'none') {
                    this.planosAcao = this.planosAcao.sort((a, b) => {
                        const valueA = a[chaveColuna] ? a[chaveColuna].toLowerCase() : '';
                        const valueB = b[chaveColuna] ? b[chaveColuna].toLowerCase() : '';

                        if (valueA < valueB) {
                            return -1;
                        }
                        if (valueA > valueB) {
                            return 1;
                        }
                        return 0;
                    });
                    document.getElementById(`setaBaixo${chaveColuna}`).style.display = 'inline'
                    document.getElementById(`setaCima${chaveColuna}`).style.display = 'none'
                    return
                } else if (document.getElementById(`setaBaixo${chaveColuna}`).style.display === 'inline') {
                    this.planosAcao = this.planosAcao.sort((a, b) => {
                        const valueA = a[chaveColuna] ? a[chaveColuna].toLowerCase() : '';
                        const valueB = b[chaveColuna] ? b[chaveColuna].toLowerCase() : '';

                        if (valueA > valueB) {
                            return -1;
                        }
                        if (valueA < valueB) {
                            return 1;
                        }
                        return 0;
                    });
                    document.getElementById(`setaBaixo${chaveColuna}`).style.display = 'none'
                    document.getElementById(`setaCima${chaveColuna}`).style.display = 'inline'
                    return
                }
            }
        },

        async atualizarPermissão(item, ação) {
            if (this.planoEditado.permissao.map((p) => p.usuario_id).includes(item.id)) {
                return;
            }
            try {
                if (ação === "adicionar") {

                    var novaPermissão = {
                        usuario_id: item.id,
                        nivel: 1,
                        nome: item.nomeCompleto
                    }
                    this.planoEditado.permissao.push(novaPermissão);

                    await servicePAP.atualizarPermissaoPlanoAcao(this.planoEditado.id, {
                        usuarios: this.planoEditado.permissao,
                    });
                }

                if (ação === "remover") {
                    this.planoEditado.permissao = this.planoEditado.permissao.filter((p) => p.usuario_id !== parseInt(item.usuario_id));
                    await servicePAP.atualizarPermissaoPlanoAcao(this.planoEditado.id, { usuarios: this.planoEditado.permissao });
                }
                if (ação === "atualizar") {
                    await servicePAP.atualizarPermissaoPlanoAcao(this.planoEditado.id, { usuarios: this.planoEditado.permissao });
                }
            } catch (error) {
                this.handleApiError(error);
            }
        },

        async onFinalizarPlano(dataTermino) {
            try {
                await servicePAP.atualizarPlanoAcao(this.planoEditado.id, {
                    dtTermino: dataTermino,
                    status: "Concluído",
                });
                this.modalFinalizarPlano = false;
                await this.getPlanoAcao();
            } catch (error) {
                this.handleApiError(error);
            }
        },

        filtrarPlanosDeAcao() {
            if (!this.planoSelecionado) {
                this.listaPlanosFiltrada = this.planosAcao;
            } else {
                const textoLowerCase = this.planoSelecionado.toLowerCase();
                this.listaPlanosFiltrada = this.planosAcao.filter(plano => {
                    return Object.values(plano).some(value => {
                        if (typeof value === 'string') {
                            return value.toLowerCase().includes(textoLowerCase);
                        }
                        return false;
                    });
                });
            }
        },

        async excluirPlano() {
            try {
                await servicePAP.excluirPlanoAcao(this.planoEditado.id, this.idUsuario);
                await servicePCM.excluirPCM(this.planoEditado.pcm_id, this.idUsuario);
                await this.getPlanoAcao();
                this.modalExcluirPlano = false;
            } catch (error) {
                this.handleApiError(error);
            }
        },

        fecharModalExcluirPlano() {
            this.modalExcluirPlano = false;
        },

        async editarPlanoInline(idProjeto, itemAlterado, novoValor) {
            try {
                const payload =
                    novoValor === "Concluído"
                        ? { [itemAlterado]: novoValor, dtTermino: dataParaInput(new Date().toISOString()) }
                        : { [itemAlterado]: novoValor, dtTermino: null };
                await servicePAP.atualizarPlanoAcao(idProjeto, payload);
                await this.getPlanoAcao();
            } catch (error) {
                this.handleApiError(error);
            }
        },

        async editarPlano(itemAlterado, novoValor) {
            try {
                await servicePAP.atualizarPlanoAcao(this.planoEditado.id, { [itemAlterado]: novoValor });
            } catch (error) {
                this.handleApiError(error);
            }
        },

        abrirModalEditarPlano(item) {
            this.planoEditado = { ...item };
            this.planoEditado.dtTermino = item.dtTermino ? dataParaInput(item.dtTermino) : "";
            this.planoEditado.dtInicio = item.dtInicio ? dataParaInput(item.dtInicio) : "";
            this.modalEditarPlano = true;
        },

        mostrarBotao(id, mostrar) {
            if (mostrar) {
                this.planoEditado = this.planosAcao.find(item => item.id === id);
                document.getElementById('botaoEdicao' + id).style.visibility = '';
            } else {
                document.getElementById('botaoEdicao' + id).style.visibility = 'hidden';
            }
        },

        async adicionarPlanoAcao() {
            try {
                await servicePAP.cadastrarPlanoAcao({
                    nome: this.novoPlanoAcao.nome,
                    dtInicio: this.novoPlanoAcao.dtInicio,
                    gerente_id: this.novoPlanoAcao.gerente_id,
                    setor_id: this.novoPlanoAcao.setor_id,
                    programa_id: this.novoPlanoAcao.programa_id,
                    usuario_id: this.idUsuario,
                    status: "Proposto",
                });
                await this.getPlanoAcao();
                this.modalNovoPA = false;
                const hoje = new Date();
                this.novoPlanoAcao = {
                    nome: "",
                    dtInicio: [hoje.getFullYear(), String(hoje.getMonth() + 1).padStart(2, "0"), String(hoje.getDate()).padStart(2, "0")].join("-"),
                    gerente_id: "",
                    setor_id: "",
                    programa_id: "",
                };
            } catch (error) {
                this.handleApiError(error);
            }
        },

        async getGerenteseSetor() {
            try {
                const { usuarios, setores } = await consultarSetores();
                this.gerente = usuarios;
                this.setores = setores;
            } catch (error) {
                this.handleApiError(error);
            }
        },

        async getPlanoAcao() {
            try {
                const funcionalidades = await servicePAP.getFuncionalidadesUsuario(this.idUsuario);
                this.dadosUser = funcionalidades?.grupo ?? funcionalidades;

                const data = await servicePAP.listarPlanosAcao();
                this.planosAcao = (Array.isArray(data) ? data : []).filter((item) => item.pcm_codigo !== null);
                this.filtrarPlanosDeAcao();
                const setaBaixo = document.getElementById("setaBaixodtInicio");
                const setaCima = document.getElementById("setaCimadtInicio");
                if (setaBaixo) setaBaixo.style.display = "none";
                if (setaCima) setaCima.style.display = "none";
                this.ordenarLista("status");
            } catch (error) {
                this.handleApiError(error);
            }
        },

        fecharModalFora(event) {
            if (event.target.classList.contains('modal-mask')) {
                this.modalNovoPA = false;
                this.modalEditarPlano = false;
                this.modalExcluirPlano = false;
                this.modalFinalizarPlano = false;
                this.modalCompartilharPlano = false;
                return this.getPlanoAcao()
            }
        },

        abrirPAP(item) {
            this.$router.push({ name: "visualizacaoPAP", params: { idPAP: item.id } });
        },
    }

}
</script>

<style scoped></style>